import jsPDF from "jspdf";
import { getReviewsByEmailReport } from "../firebase/firebase";

const generatePDF = (review) => {
  const pdf = new jsPDF();

  const marginTop = 10;
  const marginBottom = 10;

  pdf.text("Review Details - Report", 20, marginTop);
  pdf.text("Generated by Nashan", 20, marginTop + 10);

  review.forEach((review) => {
    pdf.addPage();
    let yPos = marginTop;

    // review Details
    pdf.text(`Review Details---------`, 20, yPos);
    yPos += 10;
    pdf.text(`Name: ${review.userName}`, 20, yPos);
    yPos += 10;
    pdf.text(`Email: ${review.userEmail}`, 20, yPos);
    yPos += 10;
    pdf.text(`Reviewed To: ${review.recieverEmail}`, 20, yPos);
    yPos += 10;
    pdf.text(`Reviewed Description: ${review.description}`, 20, yPos);
    yPos += 10;
    pdf.text(`Reviewed Rating: ${review.rating}`, 20, yPos);
    yPos += 10;

    yPos += 10;

    pdf.text("-----------------------------", 20, yPos);
    yPos += 10;
  });

  pdf.save("review_report.pdf");
};

export const generateReportReview = async (email) => {
  try {
    const review = await getReviewsByEmailReport(email);

    if (review) {
      generatePDF(review);
    } else {
      console.error("No DETAILS");
    }
  } catch (error) {
    console.error("Error generating report:", error);
  }
};
